// ===== Module features for easy import in ClientContainer =====

import ActivitySummary from './ActivitySummary';

const DashboardProductionModule = {
  ActivitySummary,
};

export default DashboardProductionModule;
